import {readonlyType} from '@raison/io-ts-tools';
import {Mutex} from 'async-mutex';
import {Branded, TypeOf, brand, string} from 'io-ts';

export type Jwt = Branded<string, {readonly Jwt: unique symbol}>;
export const Jwt = brand(string, (n): n is Jwt => n.length > 0, 'Jwt');

export type RefreshToken = Branded<string, {readonly RefreshToken: unique symbol}>;
export const RefreshToken = brand(string, (n): n is RefreshToken => n.length > 0, 'RefreshToken');

export type RefreshedTokenData = TypeOf<typeof RefreshedTokenData>;
export const RefreshedTokenData = readonlyType({
    access_token: Jwt,
    refresh_token: RefreshToken,
});

interface JswStore {
    readonly getJwt: () => Jwt | null;
    readonly persistJwt: (jwt: Jwt) => void;
    readonly getRefreshToken: () => RefreshToken | null;
    readonly persistRefreshToken: (refreshToken: RefreshToken) => void;
}

export interface JwtManager extends JswStore {
    readonly fetchNewRefreshToken: () => Promise<RefreshedTokenData | null>;
}

/** @private */ export const SHARED_MUTEX = new Mutex();
